import { Axios } from '@/services';

const API_VERSION = '/v2';

export const request = async (url, params) => {
  try {
    const { data } = await Axios.Api.common(`${API_VERSION}/${url}`, params);

    return data;
  } catch (err) {
    return Promise.reject();
  }
};

export const authRequest = async (url, params) => {
  try {
    const { data } = await Axios.Auth.common(`${API_VERSION}/${url}`, params);

    return data;
  } catch (err) {
    return Promise.reject();
  }
};

export const fileRequest = async (url, params) => {
  try {
    const { data, headers } = await Axios.Api.common(
      `${API_VERSION}/${url}`,
      params
    );
    const contentDisposition = headers['content-disposition'];

    return { data, contentDisposition };
  } catch (err) {
    return Promise.reject();
  }
};
